import { render, staticRenderFns } from "./gql-errors-button-list.vue?vue&type=template&id=05517d78"
import script from "./gql-errors-button-list.vue?vue&type=script&lang=js"
export * from "./gql-errors-button-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports